import { render, staticRenderFns } from "./Spider.vue?vue&type=template&id=a3c7f53e&"
import script from "./Spider.vue?vue&type=script&lang=js&"
export * from "./Spider.vue?vue&type=script&lang=js&"
import style0 from "./Spider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports